module.exports = __webpack_public_path__ + "static/media/SVG_sub_menu.c45a7133.svg";